import { Textfield } from "@/forms/ViewModelFormTypes";

export class PlantDataViewModel {
  public error = "";
  public plant: any = {};
  public plantParameters: any[] = [];
  public markerDraggable = false;
  public addressAccessRemarksText: Textfield = { value: "", error: "" };
}
